import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateAssignedUserBadgeRequestBody,
  IApiUpdateAssignedUserBadgeResponseBody,
} from '../UserBadgesApi.types';
import { useApi } from '~/lib/api/useApi';
import { searchCrowdQueryKeyFactory } from '../../Crowd/hooks/useSearchCrowdQuery';
import { userBadgesQueryKeyFactory } from './useUserBadgesQuery';

export type IUseUpdateUserBadgeRequestMutationValues = {
  appId: string;
  userBadgeId: string;
  body: IApiUpdateAssignedUserBadgeRequestBody;
};

export const useUpdateAssignedUserBadgeMutation = (): UseMutationResult<
  IApiUpdateAssignedUserBadgeResponseBody,
  unknown,
  IUseUpdateUserBadgeRequestMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.userBadges.updateAssigned(
        values.appId,
        values.userBadgeId,
        values.body,
      ),
    onSuccess: async (_updatedUserBadge, values) => {
      await queryClient.invalidateQueries({
        queryKey: userBadgesQueryKeyFactory({
          appId: values.appId,
        }),
      });

      await queryClient.invalidateQueries(
        searchCrowdQueryKeyFactory({
          appId: values.appId,
        }),
      );
    },
  });
};
